import { render, staticRenderFns } from "./VideoEnlarge.vue?vue&type=template&id=50560f32&scoped=true&"
import script from "./VideoEnlarge.vue?vue&type=script&lang=js&"
export * from "./VideoEnlarge.vue?vue&type=script&lang=js&"
import style0 from "./VideoEnlarge.vue?vue&type=style&index=0&id=50560f32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50560f32",
  null
  
)

export default component.exports